import axios from 'axios';

export const getZonesInfoForSystemIdentificationService = async (params) => {
  const response = await axios.get('/zones', { params });
  return response.data;
};

export const createUOSZoneService = async (data) => {
  const response = await axios.post('/zones', data);
  return response.data?.data;
};

export const updateUOSZoneService = async (data) => {
  const response = await axios.put(`/zones/${data.zone_id}`, data);
  return response.data?.data;
};

export const getSSRsSwitchSizesService = async () => {
  const response = await axios.get('/ssrs/ssr-switch-sizes');
  return response.data?.data;
};

export const addSSRsSwitchSizesService = async (value) => {
  const response = await axios.post('/ssrs/ssr-switch-sizes', { value });
  return response.data?.data;
};

export const getSSRsRatingListService = async () => {
  const response = await axios.get('/ssrs/ssr-rating');
  return response.data?.data;
};

export const addSSRsRatingService = async (value) => {
  const response = await axios.post('/ssrs/ssr-rating', { value });
  return response.data?.data;
};
